export function getSrcOfIframe(url: string){
    const iframeParts = url.split('iframe')[1].split('"')
    return iframeParts[iframeParts.indexOf(' src=') + 1]
}

export const makeVimeoTemplate = (id:string) => `
    <!DOCTYPE HTML>
    <html>
        <head>
            <title>Vimeo Embed</title>
            <meta name="viewport" content="width=device-width,initial-scale=1" />
            <style>body { margin: 0; }</style><style>
                .tabweb-video-container
                { position: relative; padding-bottom: 56.25%; padding-top: 35px; height: 0; overflow: hidden; }
                .tabweb-video-container iframe
                { position: absolute; top:0; left: 0; width: 100%; height: 100%; }
            </style>
        </head>
        <body>
            <div class="tabweb-video-container">
                <iframe src="https://player.vimeo.com/video/${id}" width="100%" height="600px" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
            </div>
        </body>
    </html>`

export const makeYoutubeTemplate = (id:string) => 
    `
    <!DOCTYPE HTML>
    <html>
        <head>
            <title>Document Title</title>
            <meta name="viewport" content="width=device-width,initial-scale=1" />
            <style>
                body { margin: 0; }</style><style>
                .tabweb-video-container
                { position: relative; padding-bottom: 56.25%; padding-top: 35px; height: 0; overflow: hidden; }
                .tabweb-video-container iframe
                { position: absolute; top:0; left: 0; width: 100%; height: 100%; }
            </style>
        </head>
        <body>
            <div class="tabweb-video-container">
                <iframe src="https://www.youtube.com/embed/${id}" frameborder="0" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
        </body>
    </html>
    `

export const makeGiphyTemplate = (id: string) => `
    <!DOCTYPE HTML>
    <html>
        <head>
            <title>GIF</title>
            <meta name="viewport" content="width=device-width,initial-scale=1" />
            <style>body { margin: 0; }</style>
            <style>.tabweb-video-container { position: relative; padding-bottom: 56.25%; padding-top: 35px; height: 0; overflow: hidden;} .tabweb-video-container iframe { position: absolute; top:0; left: 0; width: 100%; height: 100%; }</style>
        </head>
        <body>
            <div class="tabweb-video-container">
                <iframe src="https://giphy.com/embed/${id}" frameborder="0" allowfullscreen></iframe>
            </div>
        </body>
    </html>
`

export const makeGoogleMapsTemplate = (embedLink:string) => `
    <!DOCTYPE HTML>
    <html>
        <head>
            <title>Map</title>
            <meta name="viewport" content="width=device-width,initial-scale=1" />
            <style>body { margin: 0; }</style>
            <style>.tabweb-container { overflow:scroll; } </style>
        </head>
        <body>
            <div class="tabweb-container">
                <iframe src=${embedLink} width="100%" height="500px" frameborder="0" sandbox="allow-same-origin allow-scripts allow-popups allow-forms"></iframe>
            </div>
        </body>
    </html>
`
